import "./FieldSetEdit.scss";
import { useEffect, useState, useContext } from "react";
import {
  Col,
  Row,
  Select,
  Checkbox,
  Radio,
  Button,
  Input,
  Tooltip,
  Modal,
  Icon,
  Drawer,
  Form,
  InputNumber,
  notification
} from "antd";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useTranslation } from "react-i18next";
import { Datasources, Validation, Visibility } from "../";
import Catalogos from "../Catalogos/Catalogos";
import { formsContext, globalContext } from "../../../../../../contexts";
import { getSectionsForRiskValidation, isRiskAssignedInTree } from '../../utils/riskAssignments'

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  cursor: 'auto',

  // styles we need to apply on draggables
  ...draggableStyle
});

const FieldSetEdit = ({ form, hasHeader=true, section, component, fieldset, lang, handleChangeValuesSection, isRiskGuideDemo=false }) => {
	const { t } = useTranslation(['forms','translations'])
  const { getFieldDecorator, validateFields, setFieldsValue, setFields } = form;
  const [ isVisibleModalDS, setIsVisibleModalDS ] = useState(false)
  const [ isVisibleModalValidations, setIsVisibleModalValidations ] = useState(false)
  const [ isVisibleModalVisibility, setIsVisibleModalVisibility ] = useState(false)
  const [ isVisibleModalRecord, setIsVisibleModalRecord ] = useState(false)
  const [ isVisibleModalRisk, setIsVisibleModalRisk ] = useState(false)
  const [ selectedRiskChoice, setSelectedRiskChoice ] = useState('NONE')
  const [ selectedRiskChecked, setSelectedRiskChecked ] = useState(false)
  const [ indexField, setIndexField ] = useState(null)
  const [ showCatalogo, setShowCatalogo ] = useState(false)
  const [ keyFields, setKeyFields ] = useState("1")
  const { templateVersion, sections, clientCountry } = useContext(formsContext)
  const { datasources } = useContext(globalContext)
  const relTable = templateVersion?.template?.tipoDeclaracion === 'KYC' && templateVersion?.template?.tipoPersona !== 'Person' && (component.type === 'TABLE' || component.type === 'DECL')

  const societyRiskCodes = ['ONB-TSA', 'ONB-TSM', 'ONB-TSB']
  const riskOptions = [
    'ONB-NAT', 'ONB-EXP', 'ONB-CONS', 'ONB-MAT', 'ONB-DONA',
    ...(clientCountry === 'PER' ? ['ONB-PROVI'] : []),
    'ONB-ACTE'
  ]
  const checkboxRiskOptions = ['ONB-OCTO']

  useEffect(() => {
    if(fieldset.fields) {
      fieldset.fields.map((f, index) => {
        f.key = 'field' + (index+1)
      })
    }
    validateFields();
  }, [keyFields])

  useEffect(() => {
    setFieldsValue({['title-fieldset-' + fieldset.id]: fieldset.title && fieldset.title[lang]})
    if(fieldset.fields) {
      for(const field of fieldset.fields) {
        setFieldsValue({['title-field-' + field.id]: field.title && field.title[lang]})
      }
    }
  }, [lang])

  const handlerChangeAttr = (attr, value) => {
    fieldset[attr] = value
    if(attr === 'orientation' && value === 'horizontal') {
      fieldset.cols = 2
    }
    handleChangeValuesSection(section)

    if (attr === 'hasTitle' && !value) {
      const name = `title-fieldset-${fieldset.id}`;

      form.setFields({
        [name]: {
          value: form.getFieldValue(name),
          errors: [],
        },
      });
    }
  }

  const handleChangeTitle = (value) => {
    let title = fieldset.title??{}
    title[lang] = value
    handlerChangeAttr('title', title)
  }

  const getRandomId = () => {
    return 'R' + Math.floor(Math.random() * 1000000);
  }

  const addField = () => {
    fieldset.fields.push({
      id: getRandomId(),
      type: 'FIELD',
      typeField: 'INPUT',
      required: true,
      tableVisible: true,
      key: 'field'+(fieldset.fields.length+1)
    })
    handleChangeValuesSection(section, true)
    setKeyFields(getRandomId())
  }

  const deleteField = (index) => {
    let fields = fieldset.fields.filter((f,i) => i !== index)
    fieldset.fields = fields
    handleChangeValuesSection(section)
    setKeyFields(getRandomId())
  }

  const handleChangeFieldText = (field, value) => {
    let title = field.title??{}
    title[lang] = value
    handleChangeAttribute(field, 'title', title)
  }
  
  const handleChangeAttribute = (field, attr, value) => {
    field[attr] = value
    if(attr === 'typeField') {
      field.validation = null
      field.risks = []
      if(value === 'CHECKBOX' || value === 'SUBTITLE') {
        field.required = false
      }
    }
    handleChangeValuesSection(section)
  }

  const showVisibility = (field) => {
    setIndexField(field)
    //if(fieldset.fields[index].source) handleChangeDatasource(fieldset.fields[index].source)
    setIsVisibleModalVisibility(true)
  }

  const showDataSource = (field) => {
    setIndexField(field)
    //if(fieldset.fields[index].source) handleChangeDatasource(fieldset.fields[index].source)
    setIsVisibleModalDS(true)
  }

  const showValidations = (field) => {
    setIndexField(field)
    setIsVisibleModalValidations(true)
  }

  const showRecordField = (field) => {
    setIndexField(field)
    setIsVisibleModalRecord(true)
  }

  const showRiskSelector = (field) => {
    const selected = Array.isArray(field.risks) ? field.risks : []
    const selectedCodes = selected.map(item => item.risk)
    const availableRiskOptions = field.typeField === 'CHECKBOX' ? checkboxRiskOptions : riskOptions
    const hasCompleteSocietyGroup = societyRiskCodes.every(code => selectedCodes.includes(code))
    const choice = hasCompleteSocietyGroup
      ? 'ONB-SOCIETY'
      : selectedCodes.find(code => availableRiskOptions.includes(code)) || 'NONE'
    setIndexField(field)
    setSelectedRiskChoice(choice)
    const selectedCheckboxRisk = selected.find(item => item.risk === choice)
    setSelectedRiskChecked(typeof selectedCheckboxRisk?.checked === 'boolean' ? selectedCheckboxRisk.checked : false)
    setIsVisibleModalRisk(true)
  }

  const isRiskAssignedElsewhere = (risk) =>
    isRiskAssignedInTree(isRiskGuideDemo ? section : getSectionsForRiskValidation(sections, section), risk, indexField?.id)

  const closeRiskSelector = () => {
    setIndexField(null)
    setIsVisibleModalRisk(false)
  }

  const saveRiskRules = () => {
    const risksToSave = selectedRiskChoice === 'ONB-SOCIETY'
      ? societyRiskCodes
      : selectedRiskChoice === 'NONE' ? [] : [selectedRiskChoice]
    const alreadyAssigned = risksToSave.find(isRiskAssignedElsewhere)
    if(alreadyAssigned) {
      notification.error({
        message: t('forms.errors.error'),
        description: t('forms.manager.riskAlreadyAssigned', {
          risk: t(`messages.aml.titles.${alreadyAssigned}`, {ns: 'translations'})
        })
      })
      return
    }

    const risks = selectedRiskChoice === 'ONB-SOCIETY'
      ? societyRiskCodes.map(risk => ({ risk }))
      : selectedRiskChoice === 'NONE' ? [] : [{
        risk: selectedRiskChoice,
        ...(indexField?.typeField === 'CHECKBOX' ? { checked: selectedRiskChecked } : {})
      }]
    handleChangeAttribute(indexField, 'risks', risks)
    closeRiskSelector()
  }

  const closeModalHandlerRecord = () => {
    setIndexField(null)
    setIsVisibleModalRecord(false)
  }

  const closeModalHandlerVisibility = () => {
    setIndexField(null)
    setIsVisibleModalVisibility(false)
  }

  const closeModalHandlerDS = () => {
    setIndexField(null)
    setIsVisibleModalDS(false)
  }

  const handleClickSelectDS = (valueDS) => {
    handleChangeAttribute(indexField, 'source', valueDS)
    closeModalHandlerDS()
  }

  const closeModalHandlerValidations = () => {
    setIndexField(null)
    setIsVisibleModalValidations(false)
  }

  const handleClickSelectVisibility = (visibility) => {
    handleChangeAttribute(indexField, 'visibility', visibility)
    closeModalHandlerVisibility()
  }

  const handleClickSelectValidation = (validation) => {
    handleChangeAttribute(indexField, 'validation', validation)
    closeModalHandlerValidations()
  }

  const handleSelectRecordField = (value) => {
    handleChangeAttribute(indexField, 'record', {field: value })
    if(relTable && ['tipoDoc','dni','name','type'].includes(value)) {
      handleChangeAttribute(indexField, 'required', true)
    }
  }

  const getValidationTitle = (validation) => {
    if(validation) {
      let text = t('forms.manager.fieldsetEdit.validationsPrefix')
      if(validation.type === 'email') {
        text += t('forms.manager.fieldsetEdit.validation.email')
      }else if(validation.type === 'rut') {
        text += t('forms.manager.fieldsetEdit.validation.rut')
      }else if(validation.type === 'rutEmp') {
        text += t('forms.manager.fieldsetEdit.validation.rutEmp')
      }else if(validation.type === 'rutNat') {
        text += t('forms.manager.fieldsetEdit.validation.rutNat')
      }else if(validation.type === 'number') {
        text += t('forms.manager.fieldsetEdit.validation.number')
      }else if(validation.type === 'percent') {
        text += t('forms.manager.fieldsetEdit.validation.percent')
      }else {
        text += t('forms.manager.fieldsetEdit.validation.text')
      }
      return text
    }else {
      return t('forms.manager.fieldsetEdit.validations')
    }
  }

  const onCloseCatalogo = () => {
    setShowCatalogo(false)
  }

  const handleApplyFields = (fields) => {
    let fs = []
    if(fields.length > 0) {
      fieldset.fields.map(f => {
        fs.push(f)
      })
      fields.map(f => {
        const _f = {id: getRandomId(), title: {[lang]: f.title}, type: 'FIELD', typeField: f.type, required: f.type !== 'CHECKBOX' && f.required, tableVisible: true, key: 'field'+(fs.length+1), source: f.source, validation: f.validation, record: f.record, catalogo: true}
        if(f.record && fs.filter(fi => fi.record?.field === f.record.field).length > 0) {
          _f.record = undefined
        }
        fs.push(_f)
      })
      fieldset.fields = fs
      handleChangeValuesSection(section)
    }
    onCloseCatalogo()
  }

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const newIndex = result.destination.index
    const oldIndex = result.source.index
    if(newIndex === oldIndex) {
      return;
    }
    let fields = fieldset.fields

    let newItem = fields[oldIndex]
    if(oldIndex > newIndex) {
      for(let i = oldIndex; i>newIndex; i--) {
        fields[i] = fields[i-1]
      }
    }else {
      for(let i = oldIndex; i < newIndex; i++) {
        fields[i] = fields[i+1]
      }
    }
    fields[newIndex] = newItem

    handleChangeValuesSection(section)
  }

  const processFieldsFieldSet = (fs, field, fieldSet) => {
    if(fieldSet?.fields && fs.id !== fieldSet.id) {
      for(const f of fs.fields) {
        if(f.record?.field === field) {
          return true
        }
      }
    }
    return false
  }

  const getRecordComponentField = (components, field, fieldSet) => {
    for(const c of components) {
      if(c.type === 'FIELDSET') {
        if(processFieldsFieldSet(c, field, fieldSet)) return true
      }else if(c.type === 'PARAGRAPH' && c.fieldSet) {
        if(processFieldsFieldSet(c.fieldSet, field, fieldSet)) return true
      }else if(c.type === 'SUBSECTION' && c.components) {
        if(getRecordComponentField(c.components, field, fieldSet)) return true
      }else if(c.type === 'DECISION') {
        if(c.compSi?.components && getRecordComponentField(c.compSi.components, field, fieldSet)) return true
        if(c.compNo?.components && getRecordComponentField(c.compNo.components, field, fieldSet)) return true
      }
    }
  }

  const getRecordEnabled = (field, fieldSet) => {
    if(sections && fieldSet.fields) {
      if(fieldSet.fields.filter(f => f.record?.field === field).length > 0) {
        return false
      }else {
        for(const s of sections) {
          if(s.components && getRecordComponentField(s.components, field, fieldSet)) return true
        }
      }
    }
    return false;
  }

  const hasRelatedFieldSet = (fs, fieldSet) => {
    if(fs.id !== fieldSet.id) {
      if(fs.record?.related) {
        return true
      }
    }
    return false
  }

  const hasRelatedRecordComponent = (components, fieldSet) => {
    for(const c of components) {
      if(c.type === 'FIELDSET') {
        if(hasRelatedFieldSet(c, fieldSet)) return true
      }else if((c.type === 'TABLE' || c.type === 'DECL') && c.fieldSet) {
        if(hasRelatedFieldSet(c.fieldSet, fieldSet)) return true
      }else if(c.type === 'SUBSECTION' && c.components) {
        if(hasRelatedRecordComponent(c.components, fieldSet)) return true
      }else if(c.type === 'DECISION') {
        if(c.compSi?.components && hasRelatedRecordComponent(c.compSi.components, fieldSet)) return true
        if(c.compNo?.components && hasRelatedRecordComponent(c.compNo.components, fieldSet)) return true
      }
    }
  }

  const getRecordFieldLabel = (field) => {
    const recordField = field?.record?.field
    if(!recordField) return null

    const personType = templateVersion?.template?.tipoPersona
    const recordFieldTranslationKeys = relTable
      ? {
          tipoDoc: ['messages.aml.dniType'],
          dni: ['messages.aml.dniLarge'],
          name: ['messages.aml.name'],
          type: ['messages.aml.entityRelation'],
          email: ['messages.aml.email'],
          citizenship: ['messages.aml.nationality'],
          dateBirth: ['messages.aml.birthDate'],
          residentOf: ['messages.aml.residenceCountry']
        }
      : {
          profesion: personType === 'ALL'
            ? ['messages.aml.title.profession', 'messages.aml.title.comercialActivity']
            : [personType === 'Person' ? 'messages.aml.title.profession' : 'messages.aml.title.comercialActivity'],
          nacionalidad: personType === 'ALL'
            ? ['messages.aml.nationality', 'messages.aml.countryofregister']
            : [personType === 'Person' ? 'messages.aml.nationality' : 'messages.aml.countryofregister'],
          fecNac: personType === 'ALL'
            ? ['messages.aml.birthDate', 'messages.aml.registerDate']
            : [personType === 'Person' ? 'messages.aml.birthDate' : 'messages.aml.registerDate'],
          pais: ['messages.aml.countryofresindent'],
          proposito: ['messages.aml.title.purpose'],
          alias: personType === 'ALL'
            ? ['messages.aml.title.alias.Person', 'messages.aml.title.alias.Entity']
            : [personType === 'Person' ? 'messages.aml.title.alias.Person' : 'messages.aml.title.alias.Entity'],
          celular: ['messages.aml.title.cellphone'],
          telefono: ['messages.aml.title.phone'],
          contacto: ['messages.aml.name'],
          cargo: ['messages.aml.position'],
          paisDir: ['messages.aml.country'],
          region: ['messages.aml.region'],
          comuna: ['messages.aml.neighbourhood'],
          direccion: ['messages.aml.address'],
          paisTributaria: ['messages.aml.tax.country'],
          direccionTributaria: ['messages.aml.tax.address.complete']
        }

    const translationKeys = recordFieldTranslationKeys[recordField]
    return translationKeys
      ? translationKeys.map(key => t(key, {ns: 'translations'})).join(' / ')
      : recordField
  }

  const getDatasourceTooltip = (field) => {
    const source = field?.source
    let datasourceLabel = null

    if(source && source.indexOf(':') > 0) {
      const [sourceType, sourceCode] = source.split(':')
      const datasource = datasources?.[sourceType]?.[sourceCode]
      datasourceLabel = datasource
        ? sourceType === 'CAT'
          ? t(`forms.confirm.ds.CAT.${sourceCode}`)
          : datasource.description
        : '[N/A]'
    }

    return <>
      { t('forms.manager.fieldsetEdit.dataSource') }
      {datasourceLabel && <span>: {datasourceLabel}</span>}
    </>
  }

  const getRecordTooltip = (field) => {
    const recordFieldLabel = getRecordFieldLabel(field)
    return <>
      { relTable ? t('messages.aml.related', {ns: 'translations'}) : t('messages.aml.register', { ns: "translations" })}
      {recordFieldLabel ?
       <span>: {recordFieldLabel}</span>
       :
       <span>: {t('messages.aml.none', { ns: 'translations' })}</span>
      }
    </>
  }

  const getRiskTooltip = (risks) => {
    return <>
      {t('messages.aml.cdi.dashboard.riesgo', {ns: 'translations'})}
      {risks?.length > 0 ?
        <span>:{" "}
        {risks.map(item => t(`messages.aml.titles.${item.risk}`, {ns: 'translations'})).join(', ')}
        </span>
        :
        <span>: {t('messages.aml.none', { ns: 'translations' })}</span>
      }
    </>
  }

  const hasRelatedRecord = (fieldSet) => {
    if(sections) {
      for(const s of sections) {
        if(s.components && hasRelatedRecordComponent(s.components, fieldSet)) return true
      }
    }
    return false
  }

  return (
    <div className="form-manager-fieldset-edit">
      <div className="comp-fieldSet-edit">
        { hasHeader &&
          <Form layout="horizontal">
            <Row gutter={[0,5]}>
              <Col span={7}>
                <Form.Item label={t('forms.manager.fieldsetEdit.title')} labelCol={{span:6}} wrapperCol={{span:18}}>
                    { getFieldDecorator('title-fieldset-' + fieldset.id, {
                        initialValue: fieldset.title && fieldset.title[lang],
                        rules:
                            [
                                { required: fieldset.hasTitle, message: t('messages.aml.requestedField', {ns: 'translations'}) }
                            ]
                        })(
                            <Input onChange={(e) => handleChangeTitle(e.target.value)} size="small" disabled={!fieldset.hasTitle} />
                        )
                    }
                  </Form.Item>
              </Col>
              <Col span={1} className="chk-title">
                <Checkbox checked={fieldset.hasTitle} onChange={(e) => handlerChangeAttr('hasTitle', e.target.checked)} size="small" />
              </Col>
              <Col span={5}>
                <Form.Item label={t('forms.manager.fieldsetEdit.orientation')} labelCol={{span:10}} wrapperCol={{span:12}}>
                    { getFieldDecorator('orientation-fieldset-' + fieldset.id, {
                        initialValue: fieldset.orientation ? fieldset.orientation : "vertical"
                        })(
                          <Select style={{width:'80%'}} onChange={(value) => handlerChangeAttr('orientation', value)} size="small">
                            <Select.Option value="vertical">{t('forms.manager.fieldsetEdit.orientation.vertical')}</Select.Option>
                            <Select.Option value="horizontal">{t('forms.manager.fieldsetEdit.orientation.horizontal')}</Select.Option>
                          </Select>
                        )
                    }
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label={
                  <>
                    <Tooltip title={t('forms.manager.fieldsetEdit.columnsTooltip')}>
                      <Icon size="small" type="info-circle"/>
                    </Tooltip>
                    {t('forms.manager.fieldsetEdit.columns')}
                  </>
                } labelCol={{span:14}} wrapperCol={{span:8}}>
                    { getFieldDecorator('cols-fieldset-' + fieldset.id, {
                        initialValue: fieldset.cols
                        })(
                          <Select onChange={(value) => handlerChangeAttr('cols', value)} size="small">
                            <Select.Option value={1}>1</Select.Option>
                            <Select.Option value={2}>2</Select.Option>
                            {fieldset.orientation !== "horizontal" && <Select.Option value={3}>3</Select.Option>}
                            {fieldset.orientation !== "horizontal" && <Select.Option value={4}>4</Select.Option>}
                          </Select>
                        )
                    }
                </Form.Item>
                
              </Col>
              {(component.type === 'TABLE' || component.type === 'DECL') &&
                <>
                <Col span={6}>
                  <Form.Item label={t('forms.manager.fieldsetEdit.minRows')} labelCol={{span:16}} wrapperCol={{span:6}}>
                      { getFieldDecorator('min-rows-fieldset-' + fieldset.id, {
                          initialValue: fieldset.minRows,
                          rules:
                            [
                                { required: true, message: t('messages.aml.requestedField', {ns: 'translations'}) }
                            ]
                        })(
                            <InputNumber min={0} onChange={(e) => handlerChangeAttr('minRows', e)} size="small" style={{width:'100%'}} />
                          )
                      }
                  </Form.Item>
                </Col>
                </>
              }
              { relTable &&
                <Col span={5} offset={13}>
                  <Form.Item label={t('messages.aml.related', {ns: 'translations'})} labelCol={{span:14}} wrapperCol={{span:8}}>
                      { getFieldDecorator('relrecord-fieldset-' + fieldset.id, {
                        initialValue: fieldset.record?.related
                      })(
                          <Checkbox 
                            defaultChecked={fieldset.record?.related} 
                            onChange={(e) => handlerChangeAttr('record', { related: e.target.checked })} 
                            size="small"
                            disabled={!fieldset.record?.related && hasRelatedRecord(fieldset)}
                          />
                        )
                      }
                  </Form.Item>
                </Col>
              }
              <Col span={6} offset={((component.type === 'TABLE' || component.type === 'DECL') && !relTable) ? 18 : 0}>
                <Form.Item label={t('forms.manager.fieldsetEdit.dataCatalog')} labelCol={{span:16}} wrapperCol={{span:8}}>
                    { getFieldDecorator('catalogo-fieldset-' + fieldset.id)(
                        <Button size="small" icon="unordered-list" onClick={(e) => setShowCatalogo(true)}/>
                      )
                    }
                </Form.Item>
              </Col>
            </Row>
          </Form>
        }
        { section.type !== 'CONTACTPERSON' && section.type !== 'CONTACTENTITY' && fieldset.fields &&
          <>
            { fieldset.fields.length === 0 ?
            <Row style={{marginTop:'20px',}}>
              <Col span={3} offset={1}>
                <Button size="small" icon="plus" onClick={addField}>{t('forms.manager.fieldsetEdit.addFirstField')}</Button>
              </Col>
            </Row>
            :
            <Row className="titles-section">
              { component.type === 'PARAGRAPH' ? 
                <>
                  <Col span={1} offset={1}>{"{{#}}"}</Col>
                  <Col span={8}>{t('forms.manager.fieldsetEdit.fieldName')}</Col>
                </>
                :
                <>
                  <Col span={9} offset={1}>{t('forms.manager.fieldsetEdit.fieldName')}</Col>
                </>
              }
              <Col span={4}>{t('forms.manager.fieldsetEdit.type')}</Col>
              <Col span={component.type === 'PARAGRAPH' ? 6 : 3} className="center">{t('forms.manager.fieldsetEdit.required')}</Col>
              { (component.type === 'TABLE' || component.type === 'DECL') && <Col span={3} className="center">{t('forms.manager.fieldsetEdit.tableVisible')}</Col> }
              <Col span={component.type === 'PARAGRAPH' ? 4 : 3} className="center">{t('forms.manager.fieldsetEdit.actions')}</Col>
              { component.type !== 'PARAGRAPH' &&
                <Col span={1} className="center">{t('forms.manager.fieldsetEdit.order')}</Col>
              }
            </Row>
            }
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    className="fields-body"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    { fieldset.fields.map((field, index) =>
                      <Draggable key={field.id} draggableId={field.id} index={index}>
                        {(provided, snapshot) =>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            <Row className="rows-section">
                              <Col span={1}>
                                { section.type !== 'CONTACTPERSON' && section.type !== 'CONTACTENTITY' && index === fieldset.fields.length -1 && 
                                  <Button icon="plus" size="small" onClick={addField}/> 
                                }
                              </Col>
                              { component.type === 'PARAGRAPH' && 
                                <Col span={1}>{"{{" + (index+1) + "}}"}</Col>
                              }
                              <Col span={8}>
                                <Form.Item>
                                  { getFieldDecorator('title-field-' + field.id, {
                                      initialValue: field.title && field.title[lang],
                                      rules:
                                          [
                                            { required: true, message: t('messages.aml.requestedField', {ns: 'translations'}) },
                                            { max: 50, message: t('forms.validation.max_50_chars', {ns: 'forms'}) }
                                          ]
                                      })(
                                          <Input placeholder={t('forms.manager.fieldsetEdit.fieldNamePlaceholder')} maxLength={50} size="small" onChange={(e) => handleChangeFieldText(field, e.target.value)}/>
                                      )
                                  }
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Select data-risk-guide-target="field-type" value={field.typeField} onChange={(value) => handleChangeAttribute(field, 'typeField', value)} size="small">
                                  {component.type !== 'PARAGRAPH' &&
                                    <Select.Option value="SUBTITLE"><Col span={2}><Icon type="line"/></Col><Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.subtitle')}</Col></Select.Option>
                                  }
                                  <Select.Option value="INPUT"><Col span={2}><Icon type="edit"/></Col><Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.editable')}</Col></Select.Option>
                                  <Select.Option value="DATE"><Col span={2}><Icon type="calendar"/></Col><Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.date')}</Col></Select.Option>
                                  {component.type !== 'PARAGRAPH' &&
                                    <Select.Option value="SELECT"><Col span={2}><Icon type="unordered-list"/></Col><Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.dropdown')}</Col></Select.Option>
                                  }
                                  {component.type !== 'PARAGRAPH' &&
                                    <Select.Option value="CHECKBOX"><Col span={2}><Icon type="check-square"/></Col><Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.checkbox')}</Col></Select.Option>
                                  }
                                  {component.type !== 'PARAGRAPH' &&
                                    <Select.Option value="CHKOPTS"><Col span={2}><Icon type="check-square"/></Col><Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.checkboxMultiple')}</Col></Select.Option>
                                  }
                                  {component.type !== 'PARAGRAPH' &&
                                    <Select.Option value="RADIO"><Col span={2}><Icon type="ellipsis"/></Col><Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.closedOptions')}</Col></Select.Option>
                                  }
                                  {component.type !== 'PARAGRAPH' &&
                                    <Select.Option value="RADIOOTHER"><Col span={2}><Icon type="ellipsis"/></Col><Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.optionsOther')}</Col></Select.Option>
                                  }
                                  {component.type !== 'PARAGRAPH' &&
                                    <Select.Option value="FILE">
                                      <Col span={2}><Icon type="paper-clip"/></Col>
                                      <Col span={21}>&nbsp;&nbsp;{t('forms.manager.fieldsetEdit.file')}</Col>
                                    </Select.Option>
                                  }
                                </Select>
                              </Col>
                              <Col span={component.type === 'PARAGRAPH' ? 6 : 3} className="center">
                                  <Checkbox checked={field.required === true} disabled={field.typeField === 'CHECKBOX' || field.typeField === 'SUBTITLE'} onChange={(e) => handleChangeAttribute(field, 'required', e.target.checked)} size="small"/>
                              </Col>
                              { (component.type === 'TABLE' || component.type === 'DECL') &&
                                <Col span={3} className="center">
                                    <Checkbox checked={field.tableVisible === true} disabled={ field.typeField === 'SUBTITLE' } onChange={(e) => handleChangeAttribute(field, 'tableVisible', e.target.checked)} size="small"/>
                                </Col>
                              }
                              <Col span={4}>
                                <div className="tools-fieldset">
                                { ['INPUT','SELECT','RADIO','RADIOOTHER','CHKOPTS','CHECKBOX','FILE'].includes(field.typeField) &&
                                  <>
                                    { component.type !== 'PARAGRAPH' &&
                                      <Tooltip title={t('forms.manager.fieldsetEdit.visible')}>
                                        <Button icon="eye" size="small" onClick={() => showVisibility(field)}/>
                                      </Tooltip>
                                    }
                                    {
                                      ['SELECT','RADIO','RADIOOTHER','CHKOPTS'].includes(field.typeField) ?
                                      <Tooltip title={getDatasourceTooltip(field)}>
                                        <Button icon="unordered-list" size="small" onClick={() => showDataSource(field)}/>
                                      </Tooltip>
                                      : ['INPUT','FILE'].includes(field.typeField) &&
                                      <Tooltip title={ getValidationTitle(field.validation)}>
                                        <Button icon="check" size="small" onClick={() => showValidations(field)}/>
                                      </Tooltip>
                                    }
                                  </>
                                }
                                { templateVersion?.template?.tipoDeclaracion === 'KYC' 
                                  && (['FIELDSET','PARAGRAPH'].includes(component.type) || relTable) 
                                  && ['SELECT','INPUT','DATE','RADIO','RADIOOTHER'].includes(field.typeField) 
                                  &&
                                  <Tooltip title={getRecordTooltip(field)}>
                                    <Button icon="idcard" size="small" disabled={relTable && !fieldset.record?.related} onClick={() => showRecordField(field)}/>
                                  </Tooltip>
                                }
                                { templateVersion?.template?.tipoDeclaracion === 'KYC' && ['FIELDSET'].includes(component.type) &&
                                  <Tooltip title={getRiskTooltip(field.risks)}>
                                    <Button data-risk-guide-target="field-risk" icon="safety" size="small" disabled={ !(['SELECT','RADIO','RADIOOTHER','CHECKBOX'].includes(field.typeField)) } onClick={() => showRiskSelector(field)}/>
                                  </Tooltip>
                                }
                                <Tooltip title={t('forms.manager.fieldsetEdit.delete')}>
                                    <Button icon="delete" size="small" disabled={ fieldset.fields.length === 1 } onClick={() => deleteField(index)}/>
                                </Tooltip>
                                </div>
                              </Col>
                              { component.type !== 'PARAGRAPH' &&
                                <Col span={1} className="drag-area"><Icon type="drag"/></Col>
                              }

                            </Row>
                          </div>
                        }
                      </Draggable>
                    )}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </>
        }
      </div>
      { isVisibleModalDS &&
        <Modal
          className="modal-datasources"
          title={t('forms.manager.fieldsetEdit.dataSource')}
          footer={ null }
          visible={ true }
          onOk={ closeModalHandlerDS  }
          onCancel={ closeModalHandlerDS }
          >
            <Datasources formId={section.formId} field={indexField} handleClickSelect={handleClickSelectDS} closeModalHandler={closeModalHandlerDS} />
        </Modal>
      }

      { isVisibleModalVisibility &&
        <Modal
          className="modal-validations"
          title={t('forms.manager.fieldsetEdit.visible')}
          footer={ null }
          visible={ true }
          onOk={ closeModalHandlerVisibility }
          onCancel={ closeModalHandlerVisibility }
          style={{top: 100}}
          bodyStyle={{paddingTop:24}}
          >
            <Visibility fields={fieldset.fields} field={indexField} handleClickSelect={handleClickSelectVisibility} closeModalHandler={closeModalHandlerVisibility} lang={lang}/>
        </Modal>
      }
      { isVisibleModalValidations &&
        <Modal
          className="modal-validations"
          title={t('forms.manager.fieldsetEdit.validations')}
          footer={ null }
          visible={ true }
          onOk={ closeModalHandlerValidations  }
          onCancel={ closeModalHandlerValidations }
          >
            <Validation component={component} fields={fieldset.fields} field={indexField} handleClickSelect={handleClickSelectValidation} closeModalHandler={closeModalHandlerValidations} lang={lang}/>
        </Modal>
      }
      { isVisibleModalRecord &&
        <Modal
          className="modal-validations"
          title={t('messages.aml.register', { ns: "translations" })}
          footer={ null }
          visible={ true }
          onOk={ closeModalHandlerRecord  }
          onCancel={ closeModalHandlerRecord }
          style={{top:100}}
          >
            <>
              <Row style={{marginTop: 8, padding: '24px 0'}}>
                <p>{t('forms.manager.fieldsetEdit.recordFieldDescription')}</p>
              </Row>
              <Row className="validation-edit">
                <Form.Item label={t('forms.manager.fieldsetEdit.fieldName')}>
                  { getFieldDecorator('record-fieldset-' + fieldset.id, {
                      initialValue: indexField.record?.field || null
                      })(
                      <Select style={{width:'100%'}} onChange={handleSelectRecordField}>
                        <Select.Option value={null}>{t('messages.aml.none', { ns: "translations" })}</Select.Option>
                        { relTable &&
                          <Select.OptGroup label={t('messages.aml.related', { ns: "translations" })}>
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'tipoDoc').length === 0 &&
                              <Select.Option value="tipoDoc">{t('messages.aml.dniType', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'dni').length === 0 &&
                              <Select.Option value="dni">{t('messages.aml.dniLarge', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'name').length === 0 &&
                              <Select.Option value="name">{t('messages.aml.name', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'type').length === 0 &&
                              <Select.Option value="type">{t('messages.aml.entityRelation', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'email').length === 0 &&
                              <Select.Option value="email">{t('messages.aml.email', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'citizenship').length === 0 &&
                              <Select.Option value="citizenship">{t('messages.aml.nationality', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'dateBirth').length === 0 &&
                              <Select.Option value="dateBirth">{t('messages.aml.birthDate', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'residentOf').length === 0 &&
                              <Select.Option value="residentOf">{t('messages.aml.residenceCountry', { ns: "translations" })}</Select.Option>
                            }
                          </Select.OptGroup>
                        }
                        { !relTable &&
                          <Select.OptGroup label={t('messages.aml.basicInformation', { ns: "translations" })}>
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'profesion').length === 0 &&
                              <Select.Option value="profesion" disabled={getRecordEnabled('profesion', fieldset)}>
                                {templateVersion.template.tipoPersona === 'ALL' ? t('messages.aml.title.profession', { ns: "translations" }) + " / " + t('messages.aml.title.comercialActivity', { ns: "translations" }) 
                                : templateVersion.template.tipoPersona === 'Person' ? t('messages.aml.title.profession', { ns: "translations" })
                                : t('messages.aml.title.comercialActivity', { ns: "translations" })
                                }
                              </Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'nacionalidad').length === 0 &&
                              <Select.Option value="nacionalidad" disabled={getRecordEnabled('nacionalidad', fieldset)}>
                                {templateVersion.template.tipoPersona === 'ALL' ? t('messages.aml.nationality', { ns: "translations" }) + " / " + t('messages.aml.countryofregister', { ns: "translations" })
                                : templateVersion.template.tipoPersona === 'Person' ? t('messages.aml.nationality', { ns: "translations" })
                                : t('messages.aml.countryofregister', { ns: "translations" })
                                }
                              </Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'fecNac').length === 0 &&
                              <Select.Option value="fecNac" disabled={getRecordEnabled('fecNac', fieldset)}>
                                {templateVersion.template.tipoPersona === 'ALL' ? t('messages.aml.birthDate', { ns: "translations" }) + " / " + t('messages.aml.registerDate', { ns: "translations" })
                                : templateVersion.template.tipoPersona === 'Person' ? t('messages.aml.birthDate', { ns: "translations" })
                                : t('messages.aml.registerDate', { ns: "translations" })
                                }
                              </Select.Option>
                            }
                            { templateVersion.template.tipoPersona !== 'Entity' &&
                              fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'pais').length === 0 &&
                              <Select.Option value="pais" disabled={getRecordEnabled('pais', fieldset)}>
                                {t('messages.aml.countryofresindent', { ns: "translations" })}
                              </Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'proposito').length === 0 &&
                              <Select.Option value="proposito" disabled={getRecordEnabled('proposito', fieldset)}>{t('messages.aml.title.purpose', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'alias').length === 0 &&
                              <Select.Option value="alias" disabled={getRecordEnabled('alias', fieldset)}>
                                {templateVersion.template.tipoPersona === 'ALL' ? t('messages.aml.title.alias.Person', { ns: "translations" }) + " / " + t('messages.aml.title.alias.Entity', { ns: "translations" })
                                : templateVersion.template.tipoPersona === 'Person' ? t('messages.aml.title.alias.Person', { ns: "translations" })
                                : t('messages.aml.title.alias.Entity', { ns: "translations" })
                                }
                              </Select.Option>
                            }
                          </Select.OptGroup>
                        }
                        { !relTable &&
                          <Select.OptGroup label={t('messages.aml.contact', { ns: "translations" })}>
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'celular').length === 0 &&
                              <Select.Option value="celular" disabled={getRecordEnabled('celular', fieldset)}>{t('messages.aml.title.cellphone', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'telefono').length === 0 &&
                              <Select.Option value="telefono" disabled={getRecordEnabled('telefono', fieldset)}>{t('messages.aml.title.phone', { ns: "translations" })}</Select.Option>
                            }
                            { templateVersion.template.tipoPersona !== 'Person' &&
                              fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'contacto').length === 0 &&
                              <Select.Option value="contacto" disabled={getRecordEnabled('contacto', fieldset)}>{t('messages.aml.name', { ns: "translations" })}</Select.Option>
                            }
                            { templateVersion.template.tipoPersona !== 'Person' &&
                              fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'cargo').length === 0 &&
                              <Select.Option value="cargo" disabled={getRecordEnabled('cargo', fieldset)}>{t('messages.aml.position', { ns: "translations" })}</Select.Option>
                            }
                          </Select.OptGroup>
                        }
                        { !relTable &&
                          <Select.OptGroup label={t('messages.aml.location', { ns: "translations" })}>
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'paisDir').length === 0 &&
                              <Select.Option value="paisDir" disabled={getRecordEnabled('paisDir', fieldset)}>{t('messages.aml.country', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'region').length === 0 &&
                              <Select.Option value="region" disabled={getRecordEnabled('region', fieldset)}>{t('messages.aml.region', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'comuna').length === 0 &&
                              <Select.Option value="comuna" disabled={getRecordEnabled('comuna', fieldset)}>{t('messages.aml.neighbourhood', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'direccion').length === 0 &&
                              <Select.Option value="direccion" disabled={getRecordEnabled('direccion', fieldset)}>{t('messages.aml.address', { ns: "translations" })}</Select.Option>
                            }
                          </Select.OptGroup>
                        }
                        { !relTable &&
                          <Select.OptGroup label={t('messages.aml.tax.address', { ns: "translations" })}>
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'paisTributaria').length === 0 &&
                              <Select.Option value="paisTributaria" disabled={getRecordEnabled('paisTributaria', fieldset)}>{t('messages.aml.tax.country', { ns: "translations" })}</Select.Option>
                            }
                            { fieldset.fields.filter(f => f.id !== indexField.id && f.record?.field === 'direccionTributaria').length === 0 &&
                              <Select.Option value="direccionTributaria" disabled={getRecordEnabled('direccionTributaria', fieldset)}>{t('messages.aml.tax.address.complete', { ns: "translations" })}</Select.Option>
                            }
                          </Select.OptGroup>
                        }
                      </Select>
                      )
                  }
                </Form.Item>
                <Row className="tools-validation">
                    <Button onClick={closeModalHandlerRecord}>{t('forms.manager.validation.close')}</Button>
                </Row>
              </Row>
            </>
        </Modal>
      }
      { isVisibleModalRisk &&
        <Modal
          className="modal-risk-rules"
          zIndex={isRiskGuideDemo ? 1100 : undefined}
          title={t('messages.aml.cdi.dashboard.riesgo', {ns: 'translations'})}
          visible={true}
          onOk={saveRiskRules}
          onCancel={closeRiskSelector}
          okText={t('messages.aml.save', {ns: 'translations'})}
          cancelText={t('messages.aml.cancel', {ns: 'translations'})}
          style={{top:100}}
          width={650}
        >
          <Radio.Group
            value={selectedRiskChoice}
            onChange={event => setSelectedRiskChoice(event.target.value)}
          >
            <Row>
              <Col span={24} style={{padding: '6px 0'}}>
                <Radio value="NONE">{t('messages.aml.none', { ns: 'translations' })}</Radio>
              </Col>
              {(indexField?.typeField === 'CHECKBOX' ? checkboxRiskOptions : riskOptions).map(code =>
                <Col span={24} key={code} style={{padding: '6px 0'}}>
                  <Radio value={code} disabled={isRiskAssignedElsewhere(code)}>
                    {t(`messages.aml.titles.${code}`, {ns: 'translations'})}
                  </Radio>
                </Col>
              )}
              {indexField?.typeField !== 'CHECKBOX' &&
                <Col span={24} style={{padding: '6px 0'}}>
                  <Radio value="ONB-SOCIETY" disabled={societyRiskCodes.some(isRiskAssignedElsewhere)}>
                    {t('messages.aml.group', {ns: 'translations'})}:{' '}
                    {societyRiskCodes.map(code => t(`messages.aml.titles.${code}`, {ns: 'translations'})).join(' + ')}
                  </Radio>
                </Col>
              }
            </Row>
          </Radio.Group>
          {indexField?.typeField === 'CHECKBOX' && selectedRiskChoice !== 'NONE' &&
            <div style={{marginTop: 12}}>
              <div>{t('forms.manager.fieldsetEdit.riskCheckboxPrompt')}</div>
              <Radio.Group value={selectedRiskChecked} onChange={event => setSelectedRiskChecked(event.target.value)}>
                <Radio value={true}>{t('forms.manager.fieldsetEdit.riskCheckboxChecked')}</Radio>
                <Radio value={false}>{t('forms.manager.fieldsetEdit.riskCheckboxUnchecked')}</Radio>
              </Radio.Group>
            </div>
          }
        </Modal>
      }
      {showCatalogo && 
        <Drawer 
          title={t('forms.catalog.select_data', {ns: 'forms'})}
          placement="left"
          closable={true}
          visible={true}
          width={1300}
          onClose={onCloseCatalogo}
        >
          <Catalogos section={section} active={true} handleClose={onCloseCatalogo} handleApplyFields={handleApplyFields}/>
        </Drawer>
      }
    </div>
  )
}
export default FieldSetEdit;
